import React from "react";
import ImageUploadCantainer from ".";
import Main from "../main";
import Loader from "../Loader/Loader";

export default function AuctionImageUpload({
	handleFileChange,
	handleUpload,
	cancelHandler,
	files,
	previewImages,
	loading,
    brand,
    model,
	multipleImageStatus
}) {
	return (
		<Main>
			<ImageUploadCantainer>
                <div>
                    <h5>Brand: {brand}</h5>
                    <h5>Model: {model}</h5>
                </div>
				<ImageUploadCantainer.GroupElement>
					<ImageUploadCantainer.Label>Image Upload</ImageUploadCantainer.Label>
					<ImageUploadCantainer.FileElement
						type="file"
						name="image"
						id="image"
						accept=".png, .jpg, .jpeg"
						multiple={multipleImageStatus}
						onChange={handleFileChange}
					/>
					{multipleImageStatus && <ImageUploadCantainer.Label style={{ color: "red" }}>
						* Max 10 upload limit. When adding images, the 1st image will be set
						as thumbnail image for the tractor
					</ImageUploadCantainer.Label>}
				</ImageUploadCantainer.GroupElement>
				<div style={{display: "flex", alignItems: "center", justifyContent: "center"}}>
					<ImageUploadCantainer.SecondaryButton
						onClick={cancelHandler}
						disabled={loading}
					>
						Cancel
					</ImageUploadCantainer.SecondaryButton>
					{loading ? (
						<Loader />
					) : (
						<ImageUploadCantainer.PrimaryButton onClick={handleUpload} disabled={files.length === 0 ? true : false}>
							Upload
						</ImageUploadCantainer.PrimaryButton>
					)}
				</div>
			</ImageUploadCantainer>
		</Main>
	);
}
